type Source = { platform: string; uri?: string }

export const uniqueByName = (array: { name: string; sources: Source[] }[]) => {
  const map: Record<string, { name: string; sources: Set<Source> }> = {}
  array.forEach(item => {
    if (!map[item.name]) {
      map[item.name] = { name: item.name, sources: new Set(item.sources) }
    } else {
      item.sources.forEach(source => {
        map[item.name].sources.add(source)
      })
    }
  })
  return Object.values(map).map(item => ({ name: item.name, sources: Array.from(item.sources) }))
}
